// FETCH DATA ACTIONS
export const GET_DATA_FAIL = "GET_DATA_FAIL"
export const GET_DATA_INIT = "GET_DATA_INIT"
export const GET_DATA_SUCCESS = "GET_DATA_SUCCESS"

// UI ACTIONS
export const SET_IS_DARK_MODE = "SET_IS_DARK_MODE"

// REF ACTIONS
export const SET_ABOUT_REF = "SET_ABOUT_REF"
export const SET_ACHIEVEMENTS_REF = "SET_ACHIEVEMENTS_REF"
export const SET_BLOGS_REF = "SET_BLOGS_REF"
export const SET_CONATCT_REF = "SET_CONATCT_REF"
export const SET_EXPERIENCES_REF = "SET_EXPERIENCES_REF"
export const SET_HOME_REF = "SET_HOME_REF"
export const SET_STRENGTHS_REF = "SET_STRENGTHS_REF"